import "./Assignment.scss";

type AssignmentType = {
  children: React.ReactNode;
};

export const Assignment = (props: AssignmentType) => {
  return <section className="assignment-container">{props.children}</section>;
};
